<template>
  <hr
    :class="['roomie-divider', setSizes, setModes]"
    :style="`background-color: ${backgroundColor()};`"
    :color="color">
</template>

<script>
import COLORS from '../../../config/tailwind/colors.json'
import { BREAKPOINTS_LIST } from './utils'

export default {
  name: 'RoomieDivider',
  props: {
    size: {
      type: String,
      default: BREAKPOINTS_LIST.xs,
      validator: (value) => Object.values(BREAKPOINTS_LIST).includes(value),
    },
    color: {
      type: String,
      default: 'default'
    },
    rounded: {
      type: Boolean,
      default: false,
    },
    vertical: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    setSizes () {
      return `roomie-divider--${this.size}`
    },
    setModes () {
      return {
        'rounded': this.rounded,
        [`vertical-${this.size}`]: this.vertical,
      }
    },
  },
  methods: {
    backgroundColor () {
      if(this.color === 'default') return COLORS['carbon-light']['300']

      const titleColors = Object.keys(COLORS)
      const splitColor = this.color.split('-')
      splitColor.pop()

      const filterColor = titleColors.filter(color => color.includes(splitColor.join('-')))

      if (filterColor.length && filterColor.length < 4) {
        return COLORS[filterColor[0]][this.color.split('-').pop()]
      } else {
        return this.color
      }
    }
  }
}
</script>

<style src="./_index.scss" lang="scss" />
